import * as api from './../../api/api.service';

interface Window {
  associatedRfpId?: number;
}

/**
 * The controller to load the response-nav on the JSPX Pricing Model page
 */
export default class ResponseNavJspxWrapperController {
  account;
  rfp;

  constructor(private api: api.IApiService, $window) {
    'ngInject';

    // Check for a global RFP ID (on the window object)
    if ($window.associatedRfpId) {
      let rfpId = $window.associatedRfpId;

      api.users.currentUser().then((account) => {
        this.account = account;
      });

      api.rfps.getRfp(rfpId).then((rfp) => {
        this.rfp = rfp;
      });
    } else {
      console.warn(
        'There is no associated RFP ID for us to use! The Sub-Nav cannot work.'
      );
    }
  }
}
